import React, { useState, useRef, useCallback } from "react";
import Slider, { Settings } from "react-slick";
import { v4 as uuidV4 } from "uuid";

import * as S from "./styles";
import * as C from "components";

const IndexSlides = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

const Main: React.FC = () => {
  const slideRef = useRef<Slider>(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);

  const handleOnDotClick = useCallback((index: number) => {
    if (slideRef.current) {
      slideRef.current?.slickGoTo(index);
    }
  }, []);

  const sliderSettings: Settings = {
    // lazyLoad: "ondemand",
    slidesToShow: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 10000,
    adaptiveHeight: true,
    fade: true,
    afterChange: (i) => setActiveSlideIndex(i),
    prevArrow: (
      <S.ButtonPrev>
        <S.IconLeft />
      </S.ButtonPrev>
    ),
    nextArrow: (
      <S.ButtonNext>
        <S.IconRight />
      </S.ButtonNext>
    ),
  };
  return (
    <S.Container>
      <S.Controls>
        {IndexSlides.map((item, index) => (
          <S.Dot
            key={uuidV4()}
            onClick={() => handleOnDotClick(index)}
            active={activeSlideIndex === index}
          />
        ))}
      </S.Controls>
      <Slider ref={slideRef} {...sliderSettings}>
        <C.Slide1 key={uuidV4()} />
        <C.Slide2 key={uuidV4()} stop={activeSlideIndex !== 1} />
        <C.Slide3 key={uuidV4()} stop={activeSlideIndex !== 2} />
        <C.Slide4 key={uuidV4()} />
        <C.Slide5 key={uuidV4()} />
        <C.Slide6 key={uuidV4()} />
        <C.Slide7 key={uuidV4()} />
        <C.Slide8 key={uuidV4()} />
        <C.Slide9 key={uuidV4()} active={activeSlideIndex === 8} />
        <C.Slide10 key={uuidV4()} active={activeSlideIndex === 9} />
        <C.Slide11 key={uuidV4()} />
        <C.Slide12 key={uuidV4()} />
        <C.Slide13 key={uuidV4()} />
        <C.Slide14 key={uuidV4()} />
      </Slider>
    </S.Container>
  );
};

export default Main;
